<template>
  <div class="loading-container">
    <div class="loading-content">
      <div>
        <div align="center">
          <v-progress-circular color="primary" size="50" indeterminate></v-progress-circular>
        </div>
        <div class="mt-3" align="center">
          <h3>{{ props.message ?? "Loading..." }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  message?: string;
}>();
</script>
<style scoped>
.loading-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  transform: translateY(-10%);
}
.loading-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 200px;
  justify-content: space-around;
}
</style>
